export const BOOKING_MIN_GUESTS = 1;
export const BOOKING_MAX_GUESTS = 50;
export const BOOKING_MIN_DURATION_MIN = 30;
export const BOOKING_MAX_DURATION_MIN = 600;
export const DIRECTOR_MESSAGE_MAX_LEN = 2000;
export const DIRECTOR_MESSAGE_MIN_LEN = 5;
export const ROLES = ['CLIENT', 'ADMIN', 'DIRECTOR'];
export const BOOKING_STATUSES = ['NEW', 'CONFIRMED', 'CANCELLED'];
/** A booking counts as "active" (toward the per-user limit) only while it is
 *  still NEW (awaiting confirmation) AND its date is in the future. Confirmed,
 *  cancelled, and past bookings do NOT count — the future-date check lives in
 *  the query alongside this status filter. */
export const BOOKING_ACTIVE_STATUSES = ['NEW'];
/** Max simultaneously-active (NEW|CONFIRMED) bookings a single user may hold. */
export const MAX_ACTIVE_BOOKINGS = 10;
/** Shown both as the miniapp popup and the bot DM when the limit is reached. */
export const BOOKING_LIMIT_MESSAGE = 'Максимум может быть активно 10 бронирований';
export const MEDIA_TYPES = ['IMAGE', 'VIDEO'];
